import React, { useState } from "react";
import ImageCropper from "./ImageCropper";

export default function ImageField({ field, value, onChange, labels = {} }) {
  const [rawFile, setRawFile] = useState(null);
  const isFile = typeof File !== "undefined" && value instanceof File;
  const url = isFile ? URL.createObjectURL(value) : (typeof value === "string" && value ? value : null);
  const onPick = e => {
    const f = e.target.files && e.target.files[0];
    if (f) setRawFile(f);
    e.target.value = "";
  };
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}</label>
      {url && <img src={url} alt="" className="pt-image-preview" />}
      <div className="pt-image-actions">
        <input type="file" accept="image/*" className="pt-image-input" onChange={onPick} />
        {isFile && (
          <button type="button" className="pt-image-crop" onClick={() => setRawFile(value)}>
            {labels.crop || "Crop"}
          </button>
        )}
        {url && (
          <button type="button" className="pt-image-remove" onClick={() => onChange(field.name, "")}>
            {labels.removeImage || "Remove"}
          </button>
        )}
      </div>
      {rawFile && (
        <ImageCropper
          file={rawFile}
          labels={labels}
          onConfirm={cf => {
            onChange(field.name, cf);
            setRawFile(null);
          }}
          onCancel={() => {
            // Cropping is mandatory: cancelling discards the pick and leaves the
            // current value unchanged — an uncropped file is never uploaded.
            setRawFile(null);
          }}
        />
      )}
    </div>
  );
}
